import { render, staticRenderFns } from "./c-scroll-btn.vue?vue&type=template&id=25262636"
var script = {}
import style0 from "./c-scroll-btn.vue?vue&type=style&index=0&id=25262636&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VBtn: require('/app/node_modules/vuetify/lib/components/VBtn/VBtn.js').default})


/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
